module.exports = __webpack_public_path__ + "img/yzxckdk.a9c07137.jpg";